import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CommonBreadcrumb from "../../components/CommonBreadcrumb";
import { toast } from "react-toastify";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Button,
  Tabs,
  Tab,
  Box,
  TextField,
  Tooltip,
} from "@mui/material";
import AddFaq from "../../Modals/addFaq";
import AddBanner from "../../Modals/addBanner";
import AddVehicleBanner from "../../Modals/addVehicleBanner";
import AddCategoryBanner from "../../Modals/addCategoryBanner";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import SwitchToggle from "../../components/SwitchToggle";
import AddCMSPage from "../../Modals/addCmsPage";
import EditText from "../../components/editText";
import { usePermission } from "../../hooks/usePermission";
import Can from "../../components/Can";
import AddIcon from "@mui/icons-material/Add";
import DeleteConfirmModal from "../../Modals/DeleteConfirmModal";
import {
  useGetCmsDataQuery,
  useUpdateCmsDataMutation,
  useGetFaqsQuery,
  useAddFaqMutation,
  useUpdateFaqMutation,
  useDeleteFaqMutation,
  useGetBannersQuery,
  useAddBannerMutation,
  useUpdateBannerMutation,
  useDeleteBannerMutation,
  useUpdateBannerStatusMutation,
  useGetVehicleBannersQuery,
  useDeleteVehicleBannerMutation,
  useGetCategoryBannersQuery,
  useDeleteCategoryBannerMutation,
} from "../../service/cms/api";
import Pagination from "../../components/Panigation";
import { getVehicleTypeLabel } from "../../utils/vehicle";
import { PLATFORM_TYPE } from "../../constants/enum";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const ManageCms = () => {
  const navigate = useNavigate();
  const { hasPermission } = usePermission();
  const hasEditPermission = hasPermission("CMS Management", "isEdit");

  const [valueTabs, setValueTabs] = useState(0);
  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };

  const [bannerSubTab, setBannerSubTab] = useState(0);
  const handleChangeBannerSubTab = (event: React.SyntheticEvent, newValue: number) => {
    setBannerSubTab(newValue);
  };

  const [openModal, setOpenModal] = useState(false);
  const handleCloseModal = () => {
    setOpenModal(false);
  };
  const [openModal2, setOpenModal2] = useState(false);
  const handleCloseModal2 = () => {
    setOpenModal2(false);
  };

  const [isEdit, setIsEdit] = useState(false);

  // API Call
  // Added refetchOnMountOrArgChange to ensure we get fresh data
  const { data } = useGetCmsDataQuery(undefined, {
    refetchOnMountOrArgChange: true,
  });
  const [updateCmsData, { isLoading: isUpdating }] = useUpdateCmsDataMutation();
  const cmsData = data?.data;

  // Contact Support State
  const [contactTitle, setContactTitle] = useState("");
  const [contactTitleAr, setContactTitleAr] = useState("");
  const [contactEmail, setContactEmail] = useState("");
  const [contactPhone, setContactPhone] = useState("");
  const [contactDialCode, setContactDialCode] = useState("");

  // Privacy Policy State
  const [privacyTitle, setPrivacyTitle] = useState("");
  const [privacyTitleAr, setPrivacyTitleAr] = useState("");
  const [privacyContent, setPrivacyContent] = useState("");
  const [privacyContentAr, setPrivacyContentAr] = useState("");

  // Terms & Conditions State
  const [termsTitle, setTermsTitle] = useState("");
  const [termsTitleAr, setTermsTitleAr] = useState("");
  const [termsContent, setTermsContent] = useState("");
  const [termsContentAr, setTermsContentAr] = useState("");

  // About Us State
  const [aboutTitle, setAboutTitle] = useState("");
  const [aboutTitleAr, setAboutTitleAr] = useState("");
  const [aboutContent, setAboutContent] = useState("");
  const [aboutContentAr, setAboutContentAr] = useState("");

  const [errors, setErrors] = useState<any>({});

  // FAQs State
  const [faqList, setFaqList] = useState<any[]>([]);
  const [selectedIndex, setSelectedIndex] = useState<number | null>(null);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [faqIdToDelete, setFaqIdToDelete] = useState<string | null>(null);
  const [isDeleting, setIsDeleting] = useState(false);

  // FAQ Pagination State
  const [page, setPage] = useState(1);
  const [limit] = useState(10);

  const { data: faqsData, isFetching: isFetchingFaqs } = useGetFaqsQuery(
    { page, limit },
    { skip: valueTabs !== 4 }
  );
  const [addFaq, { isLoading: isAddingFaq }] = useAddFaqMutation();
  const [updateFaq, { isLoading: isUpdatingFaq }] = useUpdateFaqMutation();
  const [deleteFaq] = useDeleteFaqMutation();

  // Banners State
  const [bannerList, setBannerList] = useState<any[]>([]);
  const [selectedBannerIndex, setSelectedBannerIndex] = useState<number | null>(null);
  const [isBannerModalOpen, setIsBannerModalOpen] = useState(false);
  const [isBannerDeleteModalOpen, setIsBannerDeleteModalOpen] = useState(false);
  const [bannerIdToDelete, setBannerIdToDelete] = useState<string | null>(null);
  const [isDeletingBanner, setIsDeletingBanner] = useState(false);

  // Banner Pagination State
  const [bannerPage, setBannerPage] = useState(1);
  const [bannerLimit] = useState(10);

  const { data: bannersData, isFetching: isFetchingBanners } = useGetBannersQuery(
    { page: bannerPage, limit: bannerLimit },
    { skip: valueTabs !== 5 }
  );
  const [addBanner, { isLoading: isAddingBanner }] = useAddBannerMutation();
  const [updateBanner, { isLoading: isUpdatingBanner }] = useUpdateBannerMutation();
  const [deleteBanner] = useDeleteBannerMutation();
  const [updateBannerStatus] = useUpdateBannerStatusMutation();

  // Vehicle Banners State
  const [vehicleBannerList, setVehicleBannerList] = useState<any[]>([]);
  const [vehicleBannerPage, setVehicleBannerPage] = useState(1);
  const [vehicleBannerLimit] = useState(10);

  const { data: vehicleBannersData, isFetching: isFetchingVehicleBanners } = useGetVehicleBannersQuery(
    { page: vehicleBannerPage, limit: vehicleBannerLimit },
    { skip: valueTabs !== 5 || bannerSubTab !== 1 }
  );

  const [deleteVehicleBanner] = useDeleteVehicleBannerMutation();
  const [isVehicleBannerDeleteModalOpen, setIsVehicleBannerDeleteModalOpen] = useState(false);
  const [vehicleBannerIdToDelete, setVehicleBannerIdToDelete] = useState<string | null>(null);
  const [isDeletingVehicleBanner, setIsDeletingVehicleBanner] = useState(false);

  // Vehicle Banners Modal State
  const [isVehicleBannerModalOpen, setIsVehicleBannerModalOpen] = useState(false);
  const [vehicleBannerEditId, setVehicleBannerEditId] = useState<string | null>(null);

  // Category Banners State
  const [categoryBannerList, setCategoryBannerList] = useState<any[]>([]);
  const [categoryBannerPage, setCategoryBannerPage] = useState(1);
  const [categoryBannerLimit] = useState(10);
  const [isCategoryBannerModalOpen, setIsCategoryBannerModalOpen] = useState(false);
  const [categoryBannerEditId, setCategoryBannerEditId] = useState<string | null>(null);
  const [isCategoryBannerDeleteModalOpen, setIsCategoryBannerDeleteModalOpen] = useState(false);
  const [categoryBannerIdToDelete, setCategoryBannerIdToDelete] = useState<string | null>(null);
  const [isDeletingCategoryBanner, setIsDeletingCategoryBanner] = useState(false);

  const { data: categoryBannersData, isFetching: isFetchingCategoryBanners } = useGetCategoryBannersQuery(
    { page: categoryBannerPage, limit: categoryBannerLimit },
    { skip: valueTabs !== 5 || bannerSubTab !== 2 }
  );
  const [deleteCategoryBanner] = useDeleteCategoryBannerMutation();

  useEffect(() => {
    if (cmsData) {
      // console.log("CMS Data Loaded:", cmsData);

      // Contact Support
      if (cmsData?.contactSupport) {
        // console.log("Contact Support Data Loaded:", cmsData.contactSupport);
        setContactTitle(cmsData.contactSupport.pageTitle || "");
        setContactTitleAr(cmsData.contactSupport.pageTitle_ar || "");
        setContactEmail(cmsData.contactSupport.email || "");
        setContactPhone(cmsData.contactSupport.phone || "");
        setContactDialCode(cmsData.contactSupport.dialCode || "");
      }

      // Privacy Policy
      if (cmsData?.privacyPolicy) {
        setPrivacyTitle(cmsData.privacyPolicy.pageTitle || "");
        setPrivacyTitleAr(cmsData.privacyPolicy.pageTitle_ar || "");
        setPrivacyContent(cmsData.privacyPolicy.content || "");
        setPrivacyContentAr(cmsData.privacyPolicy.content_ar || "");
      }

      // Terms & Conditions (Legal)
      if (cmsData?.legal) {
        setTermsTitle(cmsData.legal.pageTitle || "");
        setTermsTitleAr(cmsData.legal.pageTitle_ar || "");
        setTermsContent(cmsData.legal.content || "");
        setTermsContentAr(cmsData.legal.content_ar || "");
      }

      // About Us - Handle potentially different property names or missing data
      // Checking 'aboutUs', 'about', or 'AboutUs'
      const aboutData = cmsData?.aboutUs || cmsData?.about || cmsData?.AboutUs;
      if (aboutData) {
        setAboutTitle(aboutData.pageTitle || "");
        setAboutTitleAr(aboutData.pageTitle_ar || "");
        setAboutContent(aboutData.content || " ");
        setAboutContentAr(aboutData.content_ar || "");
      } else {
        // console.log("About Us Data NOT Found in response");
      }

    }
  }, [cmsData]);

  useEffect(() => {
    if (faqsData?.data?.data) {
      setFaqList(faqsData.data.data);
    }
  }, [faqsData]);

  useEffect(() => {
    if (bannersData?.data?.settings) {
      setBannerList(bannersData.data.settings);
    }
  }, [bannersData]);

  useEffect(() => {
    if (vehicleBannersData?.data?.data) {
      setVehicleBannerList(vehicleBannersData.data.data);
    }
  }, [vehicleBannersData]);

  useEffect(() => {
    if (categoryBannersData?.data?.data) {
      setCategoryBannerList(categoryBannersData.data.data);
    }
  }, [categoryBannersData]);

  const validateContactSupport = () => {
    let tempErrors: any = {};
    if (!contactTitle.trim()) tempErrors.contactTitle = "Page Title is required";
    if (!contactTitleAr.trim()) tempErrors.contactTitleAr = "Page Title (Arabic) is required";
    if (!contactEmail.trim()) {
      tempErrors.contactEmail = "Email Address is required";
    } else if (!/\S+@\S+\.\S+/.test(contactEmail)) {   // NOSONAR
      tempErrors.contactEmail = "Invalid email address";
    }
    if (!contactPhone.trim()) {
      tempErrors.contactPhone = "Phone number is required";
    } else if (contactPhone.length < 7) {
      tempErrors.contactPhone = "Phone number is too short";
    }
    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const handleUpdateContactSupport = async () => {
    if (!validateContactSupport()) return;
    try {
      const payload = {
        contactSupport: {
          pageTitle: contactTitle,
          pageTitle_ar: contactTitleAr,
          email: contactEmail,
          phone: contactPhone,
          dialCode: contactDialCode,
        },
      };

      const res = await updateCmsData(payload).unwrap();
      toast.success(res?.message || "Contact Support updated successfully");
    } catch (error: any) {
      console.error("Failed to update Contact Support:", error);
      toast.error(error?.data?.message || "Failed to update Contact Support");
    }
  };

  const handleUpdatePrivacyPolicy = async () => {
    try {
      const payload = {
        privacyPolicy: {
          pageTitle: privacyTitle,
          pageTitle_ar: privacyTitleAr,
          content: privacyContent,
          content_ar: privacyContentAr,
        },
      };

      const res = await updateCmsData(payload).unwrap();
      toast.success(res?.message || "Privacy Policy updated successfully");
    } catch (error: any) {
      console.error("Failed to update Privacy Policy:", error);
      toast.error(error?.data?.message || "Failed to update Privacy Policy");
    }
  };

  const handleUpdateTerms = async () => {
    try {
      const payload = {
        legal: {
          pageTitle: termsTitle,
          pageTitle_ar: termsTitleAr,
          content: termsContent,
          content_ar: termsContentAr,
        },
      };

      const res = await updateCmsData(payload).unwrap();
      toast.success(res?.message || "Terms & Conditions updated successfully");
    } catch (error: any) {
      console.error("Failed to update Terms & Conditions:", error);
      toast.error(error?.data?.message || "Failed to update Terms & Conditions");
    }
  };

  const handleUpdateAboutUs = async () => {
    try {
      const payload = {
        aboutUs: {
          pageTitle: aboutTitle,
          pageTitle_ar: aboutTitleAr,
          content: aboutContent,
          content_ar: aboutContentAr,
        },
      };

      const res = await updateCmsData(payload).unwrap();
      toast.success(res?.message || "About Us updated successfully");
    } catch (error: any) {
      console.error("Failed to update About Us:", error);
      toast.error(error?.data?.message || "Failed to update About Us");
    }
  };


  const handleAddUpdateFaq = async (question: string, answer: string, questionAr: string, answerAr: string) => {
    const trimmedQuestion = question.trim();
    const trimmedAnswer = answer.trim();

    if (!trimmedQuestion || !trimmedAnswer) {
      toast.error("Question and Answer cannot be empty");
      return;
    }

    try {
      if (isEdit && selectedIndex !== null) {
        const id = faqList[selectedIndex]?._id;
        const res = await updateFaq({ id, question: trimmedQuestion, answer: trimmedAnswer, question_ar: questionAr, answer_ar: answerAr }).unwrap();
        toast.success(res?.message || "FAQ updated successfully");
      } else {
        const res = await addFaq({ question: trimmedQuestion, answer: trimmedAnswer, question_ar: questionAr, answer_ar: answerAr }).unwrap();
        toast.success(res?.message || "FAQ added successfully");
      }
      setOpenModal(false);
      setSelectedIndex(null);
      setIsEdit(false);
    } catch (error: any) {
      console.error("Failed to update FAQ:", error);
      toast.error(error?.data?.message || "Failed to update FAQ");
    }
  };

  const handleDeleteFaq = (id: string) => {
    setFaqIdToDelete(id);
    setIsDeleteModalOpen(true);
  };

  const confirmDeleteFaq = async () => {
    if (!faqIdToDelete) return;
    setIsDeleting(true);
    try {
      const res = await deleteFaq(faqIdToDelete).unwrap();
      toast.success(res?.message || "FAQ deleted successfully");
      setIsDeleteModalOpen(false);
      setFaqIdToDelete(null);
    } catch (error: any) {
      console.error("Failed to delete FAQ:", error);
      toast.error(error?.data?.message || "Failed to delete FAQ");
    } finally {
      setIsDeleting(false);
    }
  };

  const handleAddUpdateBanner = async (title: string, description: string, image: string, platformType: number, titleAr: string, descriptionAr: string) => {
    try {
      if (isEdit && selectedBannerIndex !== null) {
        const id = bannerList[selectedBannerIndex]?._id;
        const res = await updateBanner({ id, content: { title, description, title_ar: titleAr, description_ar: descriptionAr }, image, platformType }).unwrap();
        toast.success(res?.message || "Banner updated successfully");
      } else {
        const res = await addBanner({ content: { title, description, title_ar: titleAr, description_ar: descriptionAr }, image, isActive: true, platformType }).unwrap();
        toast.success(res?.message || "Banner added successfully");
      }
      setIsBannerModalOpen(false);
      setSelectedBannerIndex(null);
      setIsEdit(false);
    } catch (error: any) {
      console.error("Failed to update Banner:", error);
      toast.error(error?.data?.message || "Failed to update Banner");
    }
  };

  const handleDeleteBanner = (id: string) => {
    setBannerIdToDelete(id);
    setIsBannerDeleteModalOpen(true);
  };

  const confirmDeleteBanner = async () => {
    if (!bannerIdToDelete) return;
    setIsDeletingBanner(true);
    try {
      const res = await deleteBanner(bannerIdToDelete).unwrap();
      toast.success(res?.message || "Banner deleted successfully");
      setIsBannerDeleteModalOpen(false);
      setBannerIdToDelete(null);
    } catch (error: any) {
      console.error("Failed to delete Banner:", error);
      toast.error(error?.data?.message || "Failed to delete Banner");
    } finally {
      setIsDeletingBanner(false);
    }
  };

  const handleToggleBannerStatus = async (id: string, currentStatus: boolean) => {
    try {
      const res = await updateBannerStatus({ id, isActive: !currentStatus }).unwrap();
      toast.success(res?.message || "Banner status updated successfully");
    } catch (error: any) {
      console.error("Failed to update banner status:", error);
      toast.error(error?.data?.message || "Failed to update banner status");
    }
  };

  const handleDeleteVehicleBanner = (id: string) => {
    setVehicleBannerIdToDelete(id);
    setIsVehicleBannerDeleteModalOpen(true);
  };

  const confirmDeleteVehicleBanner = async () => {
    if (!vehicleBannerIdToDelete) return;
    setIsDeletingVehicleBanner(true);
    try {
      const res = await deleteVehicleBanner(vehicleBannerIdToDelete).unwrap();
      toast.success(res?.message || "Vehicle banner deleted successfully");
      setIsVehicleBannerDeleteModalOpen(false);
      setVehicleBannerIdToDelete(null);
    } catch (error: any) {
      toast.error(error?.data?.message || "Failed to delete vehicle banner");
    } finally {
      setIsDeletingVehicleBanner(false);
    }
  };

  const handleDeleteCategoryBanner = (id: string) => {
    setCategoryBannerIdToDelete(id);
    setIsCategoryBannerDeleteModalOpen(true);
  };

  const confirmDeleteCategoryBanner = async () => {
    if (!categoryBannerIdToDelete) return;
    setIsDeletingCategoryBanner(true);
    try {
      const res = await deleteCategoryBanner(categoryBannerIdToDelete).unwrap();
      toast.success(res?.message || "Category banner deleted successfully");
      setIsCategoryBannerDeleteModalOpen(false);
      setCategoryBannerIdToDelete(null);
    } catch (error: any) {
      toast.error(error?.data?.message || "Failed to delete category banner");
    } finally {
      setIsDeletingCategoryBanner(false);
    }
  };

  return (
    <>
      <CommonBreadcrumb
        title="CMS Management"
        breadcrumbItems={[
          { label: "Dashboard", onClick: () => navigate("/dashboard") },
          { label: "Manage CMS" },
        ]}
      />

      <div className="table_header">
        <div className="left_s">
          <Box className="custom_tabs1" sx={{ width: "100%" }}>
            <Tabs
              value={valueTabs}
              onChange={handleChangeTabs}
              aria-label="basic tabs example"
              className="custom_tabs_links"
            >
              <Tab label="Contact Support" {...a11yProps(0)} />
              <Tab label="Privacy Policy" {...a11yProps(1)} />
              <Tab label="Terms & Conditions" {...a11yProps(2)} />
              <Tab label="About Us" {...a11yProps(3)} />
              <Tab label="FAQ's" {...a11yProps(4)} />
              <Tab label="Banner Management" {...a11yProps(5)} />
            </Tabs>
          </Box>
        </div>
      </div>

      <div className="cards">
        <CustomTabPanel value={valueTabs} index={0}>
          <form className="form">
            <div className="gap_p">
              <div className="control_group w_50">
                <label>Page Title</label>
                <TextField
                  fullWidth
                  hiddenLabel
                  placeholder="Enter Page Title"
                  value={contactTitle}
                  onChange={(e) => {
                    const val = e.target.value.replace(/^\s+/, "").replace(/\s{2,}/g, " ");
                    if (val.length <= 40) {
                      setContactTitle(val);
                    }
                    if (errors.contactTitle) setErrors({ ...errors, contactTitle: "" });
                  }}
                  error={!!errors.contactTitle}
                  helperText={errors.contactTitle}
                  inputProps={{ maxLength: 40 }}
                />
              </div>
              <div className="control_group w_50">
                <label>عنوان الصفحة</label>
                <TextField
                  fullWidth
                  hiddenLabel
                  placeholder="أدخل عنوان الصفحة"
                  value={contactTitleAr}
                  onChange={(e) => {
                    const val = e.target.value.replace(/^\s+/, "").replace(/\s{2,}/g, " ");
                    if (val.length <= 40) {
                      setContactTitleAr(val);
                    }
                    if (errors.contactTitleAr) setErrors({ ...errors, contactTitleAr: "" });
                  }}
                  error={!!errors.contactTitleAr}
                  helperText={errors.contactTitleAr}
                  inputProps={{ maxLength: 40 }}
                />
              </div>
            </div>
            <div className="gap_p" style={{ marginTop: "20px" }}>
              <div className="control_group w_50">
                <label htmlFor="email">Email Address</label>
                <TextField
                  id="email"
                  fullWidth
                  hiddenLabel
                  placeholder="Enter here"
                  value={contactEmail}
                  onChange={(e) => {
                    setContactEmail(e.target.value);
                    if (errors.contactEmail) setErrors({ ...errors, contactEmail: "" });
                  }}
                  error={!!errors.contactEmail}
                  helperText={errors.contactEmail}
                />
              </div>
              <div className="control_group w_50">
                <label htmlFor="phone">Phone Number</label>
                <PhoneInput
                  country={"in"}
                  placeholder="Enter Phone Number"
                  enableSearch={false}
                  autoFormat={false}
                  inputStyle={{ width: "100%" }}
                  value={(contactDialCode + contactPhone).replace("+", "")}
                  onChange={(value, data: any) => {
                    setContactDialCode("+" + data.dialCode);
                    const phoneWithoutDialCode = value.slice(data.dialCode.length);
                    setContactPhone(phoneWithoutDialCode);
                    if (errors.contactPhone) setErrors({ ...errors, contactPhone: "" });
                  }}
                />
                {errors.contactPhone && (
                  <span style={{ color: "#d32f2f", fontSize: "0.75rem", marginTop: "4px", marginLeft: "14px" }}>
                    {errors.contactPhone}
                  </span>
                )}
              </div>
            </div>
            <div className="form_btn">
              <Button
                className="btn btn_primary"
                onClick={handleUpdateContactSupport}
                disabled={isUpdating || !hasEditPermission}
              >
                {isUpdating ? "Saving..." : "Save"}
              </Button>
            </div>
          </form>
        </CustomTabPanel>

        <CustomTabPanel value={valueTabs} index={1}>
          <div className="form">
            <div className="gap_p">
              <div className="control_group w_50">
                <label>Page Title</label>
                <TextField
                  fullWidth
                  hiddenLabel
                  placeholder="Enter Page Title"
                  value={privacyTitle}
                  onChange={(e) => {
                    const val = e.target.value.replace(/^\s+/, "").replace(/\s{2,}/g, " ");
                    if (val.length <= 40) {
                      setPrivacyTitle(val);
                    }
                  }}
                  inputProps={{ maxLength: 40 }}
                />
              </div>
              <div className="control_group w_50">
                <label>عنوان الصفحة</label>
                <TextField
                  fullWidth
                  hiddenLabel
                  placeholder="أدخل عنوان الصفحة"
                  value={privacyTitleAr}
                  onChange={(e) => {
                    const val = e.target.value.replace(/^\s+/, "").replace(/\s{2,}/g, " ");
                    if (val.length <= 40) {
                      setPrivacyTitleAr(val);
                    }
                  }}
                  inputProps={{ maxLength: 40 }}
                />
              </div>
            </div>
            <div className="control_group" style={{ marginTop: "20px" }}>
              <label>Content</label>
              <EditText content={privacyContent} setContent={setPrivacyContent} />
            </div>
            <div className="control_group" style={{ marginTop: "20px" }}>
              <label>المحتوى</label>
              <EditText content={privacyContentAr} setContent={setPrivacyContentAr} />
            </div>
            <div className="form_btn">
              <Button
                className="btn btn_primary"
                onClick={handleUpdatePrivacyPolicy}
                disabled={isUpdating || !hasEditPermission}
              >
                {isUpdating ? "Saving..." : "Save"}
              </Button>
            </div>
          </div>
        </CustomTabPanel>

        <CustomTabPanel value={valueTabs} index={2}>
          <div className="form">
            <div className="gap_p">
              <div className="control_group w_50">
                <label>Page Title</label>
                <TextField
                  fullWidth
                  hiddenLabel
                  placeholder="Enter Page Title"
                  value={termsTitle}
                  onChange={(e) => {
                    const val = e.target.value.replace(/^\s+/, "").replace(/\s{2,}/g, " ");
                    if (val.length <= 40) {
                      setTermsTitle(val);
                    }
                  }}
                  inputProps={{ maxLength: 40 }}
                />
              </div>
              <div className="control_group w_50">
                <label>عنوان الصفحة</label>
                <TextField
                  fullWidth
                  hiddenLabel
                  placeholder="أدخل عنوان الصفحة"
                  value={termsTitleAr}
                  onChange={(e) => {
                    const val = e.target.value.replace(/^\s+/, "").replace(/\s{2,}/g, " ");
                    if (val.length <= 40) {
                      setTermsTitleAr(val);
                    }
                  }}
                  inputProps={{ maxLength: 40 }}
                />
              </div>
            </div>
            <div className="control_group" style={{ marginTop: "20px" }}>
              <label>Content</label>
              <EditText content={termsContent} setContent={setTermsContent} />
            </div>
            <div className="control_group" style={{ marginTop: "20px" }}>
              <label>المحتوى</label>
              <EditText content={termsContentAr} setContent={setTermsContentAr} />
            </div>
            <div className="form_btn">
              <Button
                className="btn btn_primary"
                onClick={handleUpdateTerms}
                disabled={isUpdating || !hasEditPermission}
              >
                {isUpdating ? "Saving..." : "Save"}
              </Button>
            </div>
          </div>
        </CustomTabPanel>

        <CustomTabPanel value={valueTabs} index={3}>
          <div className="form">
            <div className="gap_p">
              <div className="control_group w_50">
                <label>Page Title</label>
                <TextField
                  fullWidth
                  hiddenLabel
                  placeholder="Enter Page Title"
                  value={aboutTitle}
                  onChange={(e) => {
                    const val = e.target.value.replace(/^\s+/, "").replace(/\s{2,}/g, " ");
                    if (val.length <= 40) {
                      setAboutTitle(val);
                    }
                  }}
                  inputProps={{ maxLength: 40 }}
                />
              </div>
              <div className="control_group w_50">
                <label>عنوان الصفحة</label>
                <TextField
                  fullWidth
                  hiddenLabel
                  placeholder="أدخل عنوان الصفحة"
                  value={aboutTitleAr}
                  onChange={(e) => {
                    const val = e.target.value.replace(/^\s+/, "").replace(/\s{2,}/g, " ");
                    if (val.length <= 40) {
                      setAboutTitleAr(val);
                    }
                  }}
                  inputProps={{ maxLength: 40 }}
                />
              </div>
            </div>
            <div className="control_group" style={{ marginTop: "20px" }}>
              <label>Content</label>
              <EditText content={aboutContent} setContent={setAboutContent} />
            </div>
            <div className="control_group" style={{ marginTop: "20px" }}>
              <label>محتوى</label>
              <EditText content={aboutContentAr} setContent={setAboutContentAr} />
            </div>
            <div className="form_btn">
              <Button
                className="btn btn_primary"
                onClick={handleUpdateAboutUs}
                disabled={isUpdating || !hasEditPermission}
              >
                {isUpdating ? "Saving..." : "Save"}
              </Button>
            </div>
          </div>
        </CustomTabPanel>

        <CustomTabPanel value={valueTabs} index={4}>
          <div className="table_header">
            <div className="left_s">
            </div>
            <div className="right_s">
              <Can module="CMS Management" action="isAdd" isDisabledMode={true}>
                <Button
                  className="btn btn_primary"
                  style={{ whiteSpace: "nowrap" }}
                  onClick={() => {
                    setIsEdit(false);
                    setSelectedIndex(null);
                    setOpenModal(true);
                  }}
                >
                  <AddIcon /> Add New FAQ
                </Button>
              </Can>
            </div>
          </div>
          <TableContainer className="table_container">
            <Table>
              <TableHead>
                <TableRow hover>
                  <TableCell>Sr.No</TableCell>
                  <TableCell>Question / Question (Arabic)</TableCell>
                  <TableCell>Answer / Answer (Arabic)</TableCell>
                  <TableCell>Action</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {isFetchingFaqs ? (
                  <TableRow>
                    <TableCell colSpan={4} align="center">
                      Loading FAQs...
                    </TableCell>
                  </TableRow>
                ) : faqList.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={4} align="center">
                      No FAQs found
                    </TableCell>
                  </TableRow>
                ) : (
                  faqList.map((item: any, index: number) => (
                    <TableRow hover key={index}>
                      <TableCell>{(page - 1) * limit + index + 1}</TableCell>
                      <TableCell>
                        <p style={{ margin: 0 }}>{item.question}</p>
                        {item.question_ar && (
                          <p style={{ margin: "4px 0 0", color: "#888", fontSize: "0.85em", direction: "rtl" }}>
                            {item.question_ar}
                          </p>
                        )}
                      </TableCell>
                      <TableCell className="max_c2">
                        <p style={{ margin: 0 }}>{item.answer}</p>
                        {item.answer_ar && (
                          <p style={{ margin: "4px 0 0", color: "#888", fontSize: "0.85em", direction: "rtl" }}>
                            {item.answer_ar}
                          </p>
                        )}
                      </TableCell>
                      <TableCell>
                        <div className="table_actions v2">
                          <Can module="CMS Management" action="isEdit" isDisabledMode={true}>
                            <Tooltip title="Edit" arrow>
                              <IconButton
                                onClick={() => {
                                  setIsEdit(true);
                                  setSelectedIndex(index);
                                  setOpenModal(true);
                                }}
                              >
                                <img src="/static/images/edit2_icon.svg" alt="Edit" />
                              </IconButton>
                            </Tooltip>
                          </Can>

                          <Can module="CMS Management" action="isDelete" isDisabledMode={true}>
                            <Tooltip title="Delete" arrow>
                              <IconButton onClick={() => handleDeleteFaq(item._id)}>
                                <img src="/static/images/trash2_icon.svg" alt="Delete" />
                              </IconButton>
                            </Tooltip>
                          </Can>
                        </div>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
          {faqsData?.data?.paginator && (
            <Pagination
              module={faqList}
              page={page}
              setPage={setPage}
              totalCount={faqsData.data.paginator.itemCount}
              totalPages={faqsData.data.paginator.pageCount}
              onPageChange={setPage}
            />
          )}
        </CustomTabPanel>

        <CustomTabPanel value={valueTabs} index={5}>
          <Box className="custom_tabs1" sx={{ mb: 2, width: "fit-content" }}>
            <Tabs
              value={bannerSubTab}
              onChange={handleChangeBannerSubTab}
              aria-label="banner sub tabs"
              className="custom_tabs_links"
              sx={{ width: "fit-content", minWidth: "unset" }}
            >
              <Tab label="Home Page Banner" id="banner-sub-tab-0" aria-controls="banner-sub-tabpanel-0" />
              <Tab label="Vehicle's Banner" id="banner-sub-tab-1" aria-controls="banner-sub-tabpanel-1" />
              <Tab label="Category Banner" id="banner-sub-tab-2" aria-controls="banner-sub-tabpanel-2" />
            </Tabs>
          </Box>

          <div role="tabpanel" hidden={bannerSubTab !== 0} id="banner-sub-tabpanel-0" aria-labelledby="banner-sub-tab-0">
            {bannerSubTab === 0 && (
              <>
                <div className="table_header">
                  <div className="left_s">
                  </div>
                  <div className="right_s">
                    <Can module="CMS Management" action="isAdd" isDisabledMode={true}>
                      <Button
                        className="btn btn_primary"
                        style={{ whiteSpace: "nowrap" }}
                        onClick={() => {
                          setIsEdit(false);
                          setSelectedBannerIndex(null);
                          setIsBannerModalOpen(true);
                        }}
                      >
                        <AddIcon /> Add New Banner
                      </Button>
                    </Can>
                  </div>
                </div>
                <TableContainer className="table_container">
                  <Table>
                    <TableHead>
                      <TableRow hover>
                        <TableCell>Image</TableCell>
                        <TableCell>Title / Title (Arabic)</TableCell>
                        <TableCell>Description / Description (Arabic)</TableCell>
                        <TableCell>Platform</TableCell>
                        <TableCell>Status</TableCell>
                        <TableCell>Action</TableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      {isFetchingBanners ? (
                        <TableRow>
                          <TableCell colSpan={6} align="center">
                            Loading Banners...
                          </TableCell>
                        </TableRow>
                      ) : bannerList.length === 0 ? (
                        <TableRow>
                          <TableCell colSpan={6} align="center">
                            No Banners found
                          </TableCell>
                        </TableRow>
                      ) : (
                        bannerList.map((item: any, index: number) => (
                          <TableRow hover key={index}>
                            <TableCell>
                              <div className="user_img">
                                <img
                                  src={item.image}
                                  alt={item.content?.title}
                                  style={{ width: "100px", height: "60px", objectFit: "cover", borderRadius: "4px" }}
                                />
                              </div>
                            </TableCell>
                            <TableCell>
                              <p style={{ margin: 0 }}>{item.content?.title}</p>
                              {item.content?.title_ar && (
                                <p style={{ margin: "4px 0 0", color: "#888", fontSize: "0.85em", direction: "rtl" }}>
                                  {item.content.title_ar}
                                </p>
                              )}
                            </TableCell>
                            <TableCell className="max_c2">
                              <p style={{ margin: 0 }}>{item.content?.description}</p>
                              {item.content?.description_ar && (
                                <p style={{ margin: "4px 0 0", color: "#888", fontSize: "0.85em", direction: "rtl" }}>
                                  {item.content.description_ar}
                                </p>
                              )}
                            </TableCell>
                            <TableCell>
                              {PLATFORM_TYPE[item.platformType] ?? "-"}
                            </TableCell>
                            <TableCell>
                              <SwitchToggle
                                checked={item.isActive}
                                onChange={() => handleToggleBannerStatus(item._id, item.isActive)}
                              />
                            </TableCell>
                            <TableCell>
                              <div className="table_actions v2">
                                <Can module="CMS Management" action="isEdit" isDisabledMode={true}>
                                  <Tooltip title="Edit" arrow>
                                    <IconButton
                                      onClick={() => {
                                        setIsEdit(true);
                                        setSelectedBannerIndex(index);
                                        setIsBannerModalOpen(true);
                                      }}
                                    >
                                      <img src="/static/images/edit2_icon.svg" alt="Edit" />
                                    </IconButton>
                                  </Tooltip>
                                </Can>

                                <Can module="CMS Management" action="isDelete" isDisabledMode={true}>
                                  <Tooltip title="Delete" arrow>
                                    <IconButton onClick={() => handleDeleteBanner(item._id)}>
                                      <img src="/static/images/trash2_icon.svg" alt="Delete" />
                                    </IconButton>
                                  </Tooltip>
                                </Can>
                              </div>
                            </TableCell>
                          </TableRow>
                        ))
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
                {bannersData?.data?.paginator && (
                  <Pagination
                    module={bannerList}
                    page={bannerPage}
                    setPage={setBannerPage}
                    totalCount={bannersData.data.paginator.itemCount}
                    totalPages={bannersData.data.paginator.pageCount}
                    onPageChange={setBannerPage}
                  />
                )}
              </>
            )}
          </div>

          <div role="tabpanel" hidden={bannerSubTab !== 1} id="banner-sub-tabpanel-1" aria-labelledby="banner-sub-tab-1">
            {bannerSubTab === 1 && (
              <>
                <div className="table_header">
                  <div className="left_s" />
                  <div className="right_s">
                    <Can module="CMS Management" action="isAdd" isDisabledMode={true}>
                      <Button
                        className="btn btn_primary"
                        style={{ whiteSpace: "nowrap" }}
                        onClick={() => setIsVehicleBannerModalOpen(true)}
                      >
                        <AddIcon /> Add New Banner
                      </Button>
                    </Can>
                  </div>
                </div>
                <TableContainer className="table_container">
                  <Table>
                    <TableHead>
                      <TableRow hover>
                        <TableCell>Image</TableCell>
                        <TableCell>Vehicle Type</TableCell>
                        <TableCell>Actions</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {isFetchingVehicleBanners ? (
                        <TableRow>
                          <TableCell colSpan={3} align="center">
                            Loading Vehicle Banners...
                          </TableCell>
                        </TableRow>
                      ) : vehicleBannerList.length === 0 ? (
                        <TableRow>
                          <TableCell colSpan={3} align="center">
                            No Vehicle Banners found
                          </TableCell>
                        </TableRow>
                      ) : (
                        vehicleBannerList.map((item: any) => (
                          <TableRow hover key={item._id}>
                            <TableCell>
                              <div className="user_img">
                                <img
                                  src={item.image}
                                  alt={getVehicleTypeLabel(item.type)}
                                  style={{ width: "100px", height: "60px", objectFit: "cover", borderRadius: "4px" }}
                                />
                              </div>
                            </TableCell>
                            <TableCell>{getVehicleTypeLabel(item.type)}</TableCell>
                            <TableCell>
                              <div className="table_actions v2">
                                <Can module="CMS Management" action="isEdit" isDisabledMode={true}>
                                  <Tooltip title="Edit" arrow>
                                    <IconButton
                                      onClick={() => {
                                        setVehicleBannerEditId(item._id);
                                        setIsVehicleBannerModalOpen(true);
                                      }}
                                    >
                                      <img src="/static/images/edit2_icon.svg" alt="Edit" />
                                    </IconButton>
                                  </Tooltip>
                                </Can>
                                <Can module="CMS Management" action="isDelete" isDisabledMode={true}>
                                  <Tooltip title="Delete" arrow>
                                    <IconButton onClick={() => handleDeleteVehicleBanner(item._id)}>
                                      <img src="/static/images/trash2_icon.svg" alt="Delete" />
                                    </IconButton>
                                  </Tooltip>
                                </Can>
                              </div>
                            </TableCell>
                          </TableRow>
                        ))
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
                {vehicleBannersData?.data?.paginator && (
                  <Pagination
                    module={vehicleBannerList}
                    page={vehicleBannerPage}
                    setPage={setVehicleBannerPage}
                    totalCount={vehicleBannersData.data.paginator.itemCount}
                    totalPages={vehicleBannersData.data.paginator.pageCount}
                    onPageChange={setVehicleBannerPage}
                  />
                )}
              </>
            )}
          </div>

          <div role="tabpanel" hidden={bannerSubTab !== 2} id="banner-sub-tabpanel-2" aria-labelledby="banner-sub-tab-2">
            {bannerSubTab === 2 && (
              <>
                <div className="table_header">
                  <div className="left_s" />
                  <div className="right_s">
                    <Can module="CMS Management" action="isAdd" isDisabledMode={true}>
                      <Button
                        className="btn btn_primary"
                        style={{ whiteSpace: "nowrap" }}
                        onClick={() => {
                          setCategoryBannerEditId(null);
                          setIsCategoryBannerModalOpen(true);
                        }}
                      >
                        <AddIcon /> Add New Banner
                      </Button>
                    </Can>
                  </div>
                </div>
                <TableContainer className="table_container">
                  <Table>
                    <TableHead>
                      <TableRow hover>
                        <TableCell>Image</TableCell>
                        <TableCell>Vehicle Type</TableCell>
                        <TableCell>Category</TableCell>
                        <TableCell>Action</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {isFetchingCategoryBanners ? (
                        <TableRow>
                          <TableCell colSpan={4} align="center">
                            Loading Category Banners...
                          </TableCell>
                        </TableRow>
                      ) : categoryBannerList.length === 0 ? (
                        <TableRow>
                          <TableCell colSpan={4} align="center">
                            No Category Banners found
                          </TableCell>
                        </TableRow>
                      ) : (
                        categoryBannerList.map((item: any) => (
                          <TableRow hover key={item._id}>
                            <TableCell>
                              <div className="user_img">
                                <img
                                  src={item.image}
                                  alt={getVehicleTypeLabel(item.type)}
                                  style={{ width: "100px", height: "60px", objectFit: "cover", borderRadius: "4px" }}
                                />
                              </div>
                            </TableCell>
                            <TableCell>{getVehicleTypeLabel(item.type)}</TableCell>
                            <TableCell>{item.categoryId?.name ?? item.category?.name ?? "-"}</TableCell>
                            <TableCell>
                              <div className="table_actions v2">
                                <Can module="CMS Management" action="isEdit" isDisabledMode={true}>
                                  <Tooltip title="Edit" arrow>
                                    <IconButton
                                      onClick={() => {
                                        setCategoryBannerEditId(item._id);
                                        setIsCategoryBannerModalOpen(true);
                                      }}
                                    >
                                      <img src="/static/images/edit2_icon.svg" alt="Edit" />
                                    </IconButton>
                                  </Tooltip>
                                </Can>
                                <Can module="CMS Management" action="isDelete" isDisabledMode={true}>
                                  <Tooltip title="Delete" arrow>
                                    <IconButton onClick={() => handleDeleteCategoryBanner(item._id)}>
                                      <img src="/static/images/trash2_icon.svg" alt="Delete" />
                                    </IconButton>
                                  </Tooltip>
                                </Can>
                              </div>
                            </TableCell>
                          </TableRow>
                        ))
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
                {categoryBannersData?.data?.paginator && (
                  <Pagination
                    module={categoryBannerList}
                    page={categoryBannerPage}
                    setPage={setCategoryBannerPage}
                    totalCount={categoryBannersData.data.paginator.itemCount}
                    totalPages={categoryBannersData.data.paginator.pageCount}
                    onPageChange={setCategoryBannerPage}
                  />
                )}
              </>
            )}
          </div>
        </CustomTabPanel>
      </div>

      <AddFaq
        open={openModal}
        onClose={handleCloseModal}
        setOpen={setOpenModal}
        isEdit={isEdit}
        editData={
          isEdit && selectedIndex !== null ? faqList[selectedIndex] : null
        }
        onSubmit={handleAddUpdateFaq}
        loading={isAddingFaq || isUpdatingFaq}
      />

      <AddCMSPage
        open={openModal2}
        onClose={handleCloseModal2}
        setOpen={setOpenModal2}
        isEdit={isEdit}
      />

      <DeleteConfirmModal
        open={isDeleteModalOpen}
        onClose={() => setIsDeleteModalOpen(false)}
        onConfirm={confirmDeleteFaq}
        title="Delete FAQ"
        message="Are you sure you want to delete this FAQ?"
        isLoading={isDeleting}
      />

      <AddBanner
        open={isBannerModalOpen}
        onClose={() => setIsBannerModalOpen(false)}
        setOpen={setIsBannerModalOpen}
        isEdit={isEdit}
        editData={
          isEdit && selectedBannerIndex !== null ? bannerList[selectedBannerIndex] : null
        }
        onSubmit={handleAddUpdateBanner}
        loading={isAddingBanner || isUpdatingBanner}
      />

      <DeleteConfirmModal
        open={isBannerDeleteModalOpen}
        onClose={() => setIsBannerDeleteModalOpen(false)}
        onConfirm={confirmDeleteBanner}
        title="Delete Banner"
        message="Are you sure you want to delete this banner?"
        isLoading={isDeletingBanner}
      />

      <AddVehicleBanner
        open={isVehicleBannerModalOpen}
        onClose={() => {
          setIsVehicleBannerModalOpen(false);
          setVehicleBannerEditId(null);
        }}
        setOpen={(val) => {
          setIsVehicleBannerModalOpen(val);
          if (!val) setVehicleBannerEditId(null);
        }}
        editId={vehicleBannerEditId}
      />

      <DeleteConfirmModal
        open={isVehicleBannerDeleteModalOpen}
        onClose={() => setIsVehicleBannerDeleteModalOpen(false)}
        onConfirm={confirmDeleteVehicleBanner}
        title="Delete Vehicle Banner"
        message="Are you sure you want to delete this vehicle banner?"
        isLoading={isDeletingVehicleBanner}
      />

      <AddCategoryBanner
        open={isCategoryBannerModalOpen}
        onClose={() => {
          setIsCategoryBannerModalOpen(false);
          setCategoryBannerEditId(null);
        }}
        setOpen={(val) => {
          setIsCategoryBannerModalOpen(val);
          if (!val) setCategoryBannerEditId(null);
        }}
        editId={categoryBannerEditId}
      />

      <DeleteConfirmModal
        open={isCategoryBannerDeleteModalOpen}
        onClose={() => setIsCategoryBannerDeleteModalOpen(false)}
        onConfirm={confirmDeleteCategoryBanner}
        title="Delete Category Banner"
        message="Are you sure you want to delete this category banner?"
        isLoading={isDeletingCategoryBanner}
      />
    </>
  );
};

export default ManageCms;
